import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
} from '@mui/material';
import { addAddress } from '../api/github';

export default function AddAddressModal({ open, onClose, EditAddress }) {
  const [address, setAddress] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!address.trim()) {
      setError('Манзилни киритинг.');
      return;
    }

    setLoading(true);
    try {
      await addAddress({ address, createdAt: new Date().toISOString() });
      setAddress('');
      setError('');
      onClose(true); // Указываем, что нужно обновить список
    } catch (error) {
      console.error('Ошибка при добавлении адреса:', error);
      setError('Манзилни сақлашда хатолик юз берди.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setAddress('');
    setError('');
    onClose(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Янги манзил қўшиш</DialogTitle>
      <DialogContent>
        <TextField
          label="Манзил"
          value={EditAddress ? EditAddress.address : address }
          onChange={(e) => setAddress(e.target.value)}
          fullWidth
          margin="normal"
          error={!!error}
          helperText={error}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Бекор қилиш
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : 'Сақлаш'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}